module.exports = __webpack_public_path__ + "img/gzh.0cf99b11.jpg";